import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'tpldraft',
  setup(__props, { expose: __expose }) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const addFormRef = ref<any>();

const visible = ref(false);
const addInitValue = {

};
const conditionsInitValue = {
};

const currentDraftId = ref<number>();

const items: HpsfirProFormItem[] = [
  {
    name: 'templateType',
    label: '模板类型',
    type: 'select',
    rule: [{ required: true }],
    options: [
      {
        label: '普通模板',
        value: 0,
      },
      {
        label: '标准模板',
        value: 1,
      },
    ],
  },
];


const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'draftId',
      label: '草稿ID',
      type: 'number',
    },
    {
      name: 'currentVersion',
      label: '版本',
      type: 'string',
    },
    {
      name: 'description',
      label: '描述',
      type: 'string',
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },

  ]);
});


const operates: any[] = [
  {
    key: 'addTpl',
    name: '添加到模板库',
    handler: useBaseAsync((row: any) => {
      // tpldraftRef.value?.show();
      currentDraftId.value = row.draftId;
      addFormRef.value?.reset();
      addFormRef.value?.showDialog();
    }),
  },
];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().weappTplApi.getTplDraftListweappTpl();
    const tableData: HpsfirProTableData = {
      total: res.data.data?.length || 0,
      data: res.data.data || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const handleOk = useBaseAsync(async(data: any) => {
  data.draftId = currentDraftId.value;
  await useApi().weappTplApi.addTplweappTpl(data);
  ElMessage.success('添加成功');
  visible.value = false;
});


const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;


init();
__expose({
  show: () => {
    tableRef.value?.refresh();
    visible.value = true;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!
  const _component_HpsfirProForm = _resolveComponent("HpsfirProForm")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createBlock(_component_HpsfirProDrawer, {
    open: visible.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "模板草稿",
    width: "80vw",
    "max-width": "1200px",
    "content-class": "business-table-drawer",
    "body-class": "business-table-drawer__body"
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_HpsfirProTable, {
            key: 0,
            ref_key: "tableRef",
            ref: tableRef,
            "export-file-name": "模板草稿",
            columns: columns.value,
            "get-data": _unref(getData),
            loading: loading.value,
            "is-dangder-delete": true,
            "format-dangder-delete-info": formatDeleteInfo,
            "row-key": "id",
            operates: operates,
            "add-init-values": addInitValue,
            "codition-init-values": conditionsInitValue
          }, null, 8, ["columns", "get-data", "loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_HpsfirProForm, {
        "is-dialog": true,
        ref_key: "addFormRef",
        ref: addFormRef,
        title: "添加到模板库",
        items: items,
        onOk: _unref(handleOk)
      }, null, 8, ["onOk"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})